import { useCallback } from "react";
import { contact } from "../models/site";
import { useGoogleMapPresenter } from "../presenters/useGoogleMapPresenter";

const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? "";

export function GoogleFooterMap() {
  const openGoogleMaps = useCallback(() => {
    window.open(contact.map, "_blank", "noopener,noreferrer");
  }, []);
  const { containerRef, status } = useGoogleMapPresenter({
    apiKey: googleMapsApiKey,
    latitude: contact.coordinates.latitude,
    longitude: contact.coordinates.longitude,
    placeId: contact.placeId,
    onMarkerActivate: openGoogleMaps,
  });
  const ready = status === "ready";
  const unavailable = status === "unavailable" || status === "error";

  return (
    <div className="footer-map" aria-label="都蘭小星民宿 Google 地圖">
      <div
        className={ready ? "footer-map-canvas is-ready" : "footer-map-canvas"}
        ref={containerRef}
      />
      {!ready && (
        <a
          className="footer-map-placeholder"
          href={contact.map}
          target="_blank"
          rel="noreferrer"
        >
          <span aria-hidden="true" className="footer-map-placeholder-pin" />
          <strong>{unavailable ? "Google Map" : "Loading map…"}</strong>
          <small>{unavailable ? "在 Google 地圖開啟" : "都蘭小星民宿"}</small>
        </a>
      )}
      <a
        className="sr-only"
        href={contact.map}
        target="_blank"
        rel="noreferrer"
      >
        在 Google 地圖開啟都蘭小星民宿位置
      </a>
    </div>
  );
}
